export default __webpack_public_path__ + "static/media/checkgreen.b7b2fca4.svg";